// reducers.js
import { combineReducers } from "redux";
import {
  worksReducer,
  selectedWorkReducer
} from "../actions/workStoreFunctions";
import {
  clientsReducer,
  selectedClientReducer
} from "../actions/clientStoreFunctions";
import authReducer from "../actions/authStoreFunctions";
import {
  objectReducer,
  selectedObjectReducer,
  objectLoadingReducer,
  createdItemsReducer,
  createdTablesReducer
} from "../actions/objectStoreFunctions";
import { colorReducer } from "../actions/colorStoreFunctions";
import { imageReducer } from "../actions/imageStoreFunctions";
import {
  scriptReducer,
  selectedScriptReducer,
  scriptItemsReducer
} from "../actions/scriptStoreFunctions";
import { tablesReducer } from "../actions/tableStoreFunctions";
import { settingReducer } from "../actions/settingStoreFunctions";
import { reportsReducer } from "../actions/reportStoreFunctions";
import { workFileReducer } from "../actions/workFileStoreFunctions";
import { scriptSaveReducer } from "../actions/scriptSaveStoreFunctions";
import { millingReducer } from "../actions/millingStoreFunctions";
// (ha kell külön itemsReducer)
const itemsReducer = (state = [], action) => {
  switch (action.type) {
    case "UPDATE_ITEMS":
      return action.payload;
    default:
      return state;
  }
};

// 1) Az app szintű reducer-ek összefűzése
const appReducer = combineReducers({
  selectedClient: selectedClientReducer,
  selectedWork: selectedWorkReducer,
  selectedScript: selectedScriptReducer,
  scriptItems: scriptItemsReducer,
  clients: clientsReducer,
  works: worksReducer,
  auth: authReducer,
  colors: colorReducer,
  images: imageReducer,
  scripts: scriptReducer,
  selectedObject: selectedObjectReducer,
  settings: settingReducer,
  items: itemsReducer,
  objects: objectReducer,
  objectLoading: objectLoadingReducer,
  createdItems: createdItemsReducer,
  createdTables: createdTablesReducer,
  tables: tablesReducer,
  reports: reportsReducer,
  workFile: workFileReducer,
  millings: millingReducer,
  scriptSaves: scriptSaveReducer
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT_SUCCESS" || action.type === "auth/logout") {
    state = undefined;
  }
  return appReducer(state, action);
};

// 3) A store ezt importálja
export default rootReducer;
